<template>
    <div>
        <a-card title="调度日志">
            
            <a-form layout="inline" @submit="handleSubmit" :form="form" >
                <a-form-item label="执行器">
                    <a-select mode="default" v-model="searchP.jobGroup" style="width: 120px;" placeholder="请选择执行器" show-search @change="handleJobGroupChange">
                        <a-select-option :key="0">
                            全部
                        </a-select-option>
                        <a-select-option v-for="item in JobGroupList" :key="item.id">
                            {{ item.title }}
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="任务">
                    <a-select mode="default" v-model="searchP.jobId" style="width: 250px;" placeholder="请选择任务"
                        show-search>
                        <a-select-option value="0">
                            全部
                        </a-select-option>

                        <a-select-option v-for="item in JobTaskList" :key="item.id">
                            {{item.jobDesc}}
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="状态">
                    <a-select mode="default" v-model="searchP.logStatus" style="width: 80px;" placeholder="请选择状态"
                        show-search>
                        <a-select-option value="-1">
                            全部
                        </a-select-option>
                        <a-select-option value="1">
                            成功
                        </a-select-option>
                        <a-select-option value="2">
                            失败
                        </a-select-option>
                        <a-select-option value="3">
                            进行中
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="调度时间">
                    <a-input v-model="searchP.filterTime" style="width:320px" placeholder="请选择调度时间"></a-input>

                    <a-select mode="default" v-model="chartPerTime" @change="handleChartPerTimeChange" style="width: 80px;margin-left:12px;" placeholder="请选择时间">
                    <a-select-option v-for="(value,name) in perTimeValue" :key="name" :value="value">
                            {{name}}
                        </a-select-option>
                    </a-select>

                </a-form-item>

                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>

                
            </a-form>

            <!-- 系统列表 -->
            <a-table :columns="columns" :data-source="list" :scroll="{ x: 800}" :pagination="false" :loading="tLoading" rowKey="id" style="margin-top:20px;" >
                <template slot="jobIDS" slot-scope="text,record">
                    <a-button type="link" @click="handleRecordIdClick(record)">{{record.jobId}}</a-button>
                </template>
                <template slot="triggerMsgs" slot-scope="text">
                    <a-button v-if="text" type="link" @click="handleRemarkModal(text,'调度备注')">查看</a-button>
                    <span v-else>无</span>
                </template>
                <template slot="handleMsgs" slot-scope="text">
                    <a-button v-if="text" type="link" @click="handleRemarkModal(text,'执行备注')">查看</a-button>
                    <span v-else>无</span>
                </template>
                
                <a-tag :color="text == '200' ? '#87d068' : 'gray'" slot="triggerCodes" slot-scope="text">{{ text == '200' ? '成功' : '失败' }}</a-tag>
                <template slot="operation" slot-scope="text,record">
                    <a-button type="link" @click="handleTaskLog(record)">执行日志</a-button>
                    <a-button v-if="record.handleCode == 0" type="link" class="ml10" @click="handleKillTask(record)">终止任务</a-button>
                </template>
                <template slot="handleCodes" slot-scope="text">
                    <span v-if="text == 200" style="color: green">成功</span>
                    <span v-if="text == 500" style="color: red">失败</span>
                    <span v-if="text == 502" style="color: red">失败(超时)</span>
                    <span v-else></span>
                </template>
            </a-table>
            
            <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />

            <a-modal v-model="visible" :title="modalTitle" :footer="null">
                <div v-html="modalContent"></div>
            </a-modal>
        </a-card>
    </div>
</template>

<script>
import lodash from 'lodash'
const perTimeValue = {
    '今天':'1',
    '昨天':'2',
    '本周':'3',
    '上周':'4',
    '本月':'5',
    '上月':'6',
}
const colums = [
    {
        title: "任务ID",
        width: 80,
        align: "center",
        dataIndex: 'jobId',
        scopedSlots: { customRender: 'jobIDS' },
    },
    {
        title: '调度时间',
        dataIndex: 'triggerTime',
        align: 'center',
        width:180,
        customRender: (text) => {
            return text?new Date(text).Format("yyyy-MM-dd hh:mm:ss"):"";
        },
    },
    {
        title: '调度结果',
        dataIndex: 'triggerCode',
        align: 'center',
        width:100,
        scopedSlots:{ customRender:'triggerCodes' }
    },
    {
        title: '调度备注',
        dataIndex: 'triggerMsg',
        align: 'center',
        width:100,
        scopedSlots: { customRender: 'triggerMsgs' },
    },
    {
        title: '执行时间',
        dataIndex: 'handleTime',
        align: 'center',
        width:180,
        customRender: (text) => {
            return text?new Date(text).Format("yyyy-MM-dd hh:mm:ss"):"";
        },
    },
    
    {
        title: '执行结果',
        dataIndex: 'handleCode',
        align: 'center',
        width:80,
        scopedSlots: { customRender: 'handleCodes' },
    },

    {
        title: '执行备注',
        dataIndex: 'handleMsg',
        align: 'center',
        width:120,
        scopedSlots: { customRender: 'handleMsgs' },
    },

    {
        title: '操作',
        dataIndex: 'operation',
        width:200,
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    }
                
];

export default {
    components: {
    },
    mounted() {
        console.log(lodash.add(0.1,0.2))
        this.handleChartPerTimeChange();
        this.getEnum();
    },
    data() {
        return {
            
            perTimeValue,
            chartPerTime:'1',
            form: this.$form.createForm(this),
            tLoading:false,
            searchP:{
                jobGroup:0,
                jobId:'0',
                logStatus:'-1',
                filterTime:'',
                length:10,
                start:0,
                page:1,
                total:0
            },
            visible:false,
            modalTitle:'',
            modalContent:'',
            list:[],
            ExecutorRouteStrategyEnum:[],//路由策略-列表
            GlueTypeEnum:[],//Glue类型-字典
            ExecutorBlockStrategyEnum:[],//阻塞处理策略-字典
            ScheduleTypeEnum:[],//调度类型
            MisfireStrategyEnum:[],//调度过期策略
            JobGroupList:[],//
            JobTaskList:[],
            columns:colums
        };
    },
    methods: {
        //执行器和任务联动
        handleJobGroupChange(v){
            console.log(v)
            let that = this;
            that.$store.dispatch({
                type: 'jobcenter/getJobsByGroup',
                params: {
                    jobGroup:v,
                    urlparams:false,
                }
            }).then((res) => {
                let res1 = res.data;
                if (res1.code == 200) {
                    that.JobTaskList = res.data.content
                }
                else{
                    that.JobTaskList = []
                }
                const { query } = that.$route;
                if(query.jobId != undefined){
                    that.searchP.jobId = parseInt(query.jobId);
                    that.getData();
                }
            });
        },
        handleChartPerTimeChange(){
            let tempData = this.G.getRecentDate(this.chartPerTime);
            let start_t= new Date(tempData.start_time).Format('yyyy-MM-dd hh:mm:ss')
            let end_t = new Date(tempData.end_time).Format('yyyy-MM-dd hh:mm:ss')
            this.searchP.filterTime = start_t + ' - ' + end_t
        },
        //终止任务
        handleKillTask(row){
            let that = this;
            this.$confirm({
                title: '系统提示',
                content: '确定终止任务?',
                onOk() {
                    that.$store.dispatch({
                        type: 'jobcenter/logKill',
                        params: {
                            id:row.id,
                            urlparams:false,
                        }
                    }).then((res) => {
                        let res1 = res.data;
                        if (res1.code == 200) {
                            that.message.success('操作成功')
                        }
                        else{
                            that.message.error(res1.msg)
                        }
                    });
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        //执行日志
        handleTaskLog(row){
            this.$router.push({
                path: 'logdetail',
                query: {
                    triggerCode:row.triggerCode,
                    handleCode:row.handleCode,
                    executorAddress:row.executorAddress,
                    triggerTime:row.triggerTime,
                    id:row.id
                }
            })
        },
        handleRemarkModal(text,title){
            this.modalTitle = title;
            this.modalContent = text;
            this.visible = true;
        },

        handleRecordIdClick(row){
            this.$success({
                title: '任务信息',
                // JSX support
                content: (
                    <div>
                        <p><span class="fwb mr10">JobHandler:</span><span>{row.executorHandler}</span></p>
                        <p><span class="fwb mr10">执行器地址:</span><span>{row.executorAddress}</span></p>
                        <p><span class="fwb mr10">V5版本-风控服务servicekey:</span><span>{row.executorParam}</span></p>
                    </div>
                ),
            });
        },
        getEnum(){
            let that = this;
            that.$store.dispatch({
                type: 'jobcenter/queryEnum',
                params: {
                    urlparams:false,
                }
            }).then((res) => {
                let res1 = res.data;
                if(res1.success == 1){
                    let result = res1.data;
                    that.ExecutorRouteStrategyEnum = result.ExecutorRouteStrategyEnum;
                    that.GlueTypeEnum = result.GlueTypeEnum;
                    that.ExecutorBlockStrategyEnum = result.ExecutorBlockStrategyEnum;
                    that.ScheduleTypeEnum = result.ScheduleTypeEnum;
                    that.MisfireStrategyEnum = result.MisfireStrategyEnum;
                    that.JobGroupList = result.JobGroupList;
                    const {query} = that.$route;
                    if(query.jobGroup != undefined){
                        that.searchP.jobGroup = parseInt(query.jobGroup);
                        that.handleJobGroupChange(that.searchP.jobGroup)
                    }
                    else{
                        that.getData();
                    }
                }
            });
        },
        getData(){
            let that = this;
            that.tLoading = true;
            that.searchP.start = (that.searchP.page - 1) * that.searchP.length;
            that.$store.dispatch({
                type: 'jobcenter/loglist',
                params: that.searchP,
            }).then((res) => {
                if(res.status == 200){
                    let result = res.data;
                    that.list = result.data;
                    that.searchP.total = result.recordsTotal;
                }
                that.tLoading = false;
            });
        },
        //筛选提交
        handleSubmit(e) {
            e && e.preventDefault();
            this.searchP.page = 1;
            this.getData()
        },
        // 分页事件
        handlePageChange(c){
            this.searchP.page = c;
            this.getData()
        },
        //筛选重置
        handleSearchReset() {
            this.searchP = {
                jobGroup:0,
                jobId:'0',
                logStatus:'-1',
                filterTime:'',
                length:10,
                start:0,
                page:1,
                total:0
            }
            this.getData();
        },


        handleExportService(flag){

            
            let exportIds = this.selectedRowKeys.join(',')
            if(flag == 'export_select'){
                //导出选中
                if(!exportIds){
                    this.message.error('请勾选需要导出的列')
                    return
                }
            }
            else{
                //导出所有
                if(exportIds){
                    this.message.error('导出所有时，请不要选中列')
                    return
                }
            }
            let businesstype = this.searchP.extype == 'export' ? "fmsExportPlatformConfig" : "fmsExportPlatformImportConfig"
            this.isExporting = true
            this.$store
                .dispatch({
                    type: 'servicekey/exportService',
                    params: {
                        exportbusinesstype:businesstype,
                        exportparamsdesc:'{}',
                        type:this.searchP.type,
                        exportids:exportIds,
                        urlparams:false
                    }
                })
                .then((res) => {
                    if(res.data.success == '1'){
                        console.log(res)
                        this.exportId = res.data.data
                        this.checkExportStatue();
                      
                    }
                    else{
                        this.isExporting = false;
                        this.message.error('导出失败')
                    }
                }).catch((e) => {
                    this.isExporting = false;
                    this.message.error('导出失败'+e.message)
                });
        },

        checkExportStatue(){
            if(this.checkStatuesTime > 3){
                this.message.error('超出请求次数')
                this.checkStatuesTime = 0;
                clearTimeout(this.timer)
                this.isExporting = false
                return;
            }
            let that = this;
            this.timer = setTimeout(function(){
                that.$store
                    .dispatch({
                        type: 'servicekey/checkExportStatue',
                        params: {id:that.exportId}
                    })
                    .then((res) => {
                        if(res.data.success == 1){
                            if(res.data.data.exportstatus == 1){
                                //导出成功
                                that.isExporting = false
                                let temp_File_Str = res.data.data.exportfilefull;
                                let files = temp_File_Str.split(',')
                                for (let index = 0; index < files.length; index++) {
                                    const element = files[index];
                                    window.open(element)
                                }
                                
                            }
                            else{
                                that.checkExportStatue()
                            }
                        }
                        else{
                            that.checkExportStatue()
                        }
                        console.log(res)
                        that.checkStatuesTime++
                    });
            },2000);
            
        },
    },

    
};

</script>

<style lang="less" scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}

.ant-dropdown-menu-item{
    padding: 5px 12px;
}

.my_divider{
    background-color: #eee;
    padding:0.5px;
}
</style>
